import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';


const BlockStyleSeven = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <div className="block-style-seven pl-90 mb-45 pl-md-0">
                <h6 className="sub-title-two mb-20">{t('block6')}</h6>
                <h2 className="sect-title mb-20">{t('block7')}</h2>
                <p>{t('block8')}</p>
                <div className="icon-box">
                    <span><img src="assets/img/icon/icon-28c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-29c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-30c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-31c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-32c.svg" alt="icon"/></span>
                </div>
                <Link className="theme_btn mt-55" to="/about">{t('block9')}</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleSeven